import React, { useEffect, useRef, useState } from "react";
import { FiChevronDown } from "react-icons/fi";

export default function FinderSelect({
  name,
  value,
  onChange,
  options,
  placeholder = "Select",
  ariaLabel,
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const selectedOption = options.find((option) => option.value === value);
  const displayLabel = selectedOption?.label || placeholder;

  useEffect(() => {
    if (!open) return undefined;

    const handleOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    document.addEventListener("keydown", handleEscape);
    document.body.classList.add("finder-select-open");

    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
      document.removeEventListener("keydown", handleEscape);
      document.body.classList.remove("finder-select-open");
    };
  }, [open]);

  const handleSelect = (optionValue) => {
    onChange({ target: { name, value: optionValue } });
    setOpen(false);
  };

  return (
    <div className={`finder-custom-select ${open ? "is-open" : ""}`} ref={rootRef}>
      <button
        type="button"
        className="finder-select-trigger"
        onClick={() => setOpen((prev) => !prev)}
        aria-label={ariaLabel}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <span className={!selectedOption ? "is-placeholder" : ""}>{displayLabel}</span>
        <FiChevronDown className="finder-select-chevron" aria-hidden="true" />
      </button>

      {open && (
        <>
          <button
            type="button"
            className="finder-select-backdrop"
            aria-label="Close options"
            onClick={() => setOpen(false)}
          />
          <div className="finder-select-panel" role="listbox" aria-label={ariaLabel}>
            <div className="finder-select-panel-header">
              <span>{ariaLabel}</span>
              <button type="button" className="finder-select-done" onClick={() => setOpen(false)}>
                Done
              </button>
            </div>
            <ul className="finder-select-options">
              {options.map((option) => (
                <li key={`${name}-${option.value || "empty"}`}>
                  <button
                    type="button"
                    className={`finder-select-option ${value === option.value ? "is-selected" : ""}`}
                    onClick={() => handleSelect(option.value)}
                    role="option"
                    aria-selected={value === option.value}
                  >
                    {option.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}
